import { render, staticRenderFns } from "./MessengerPageSelector.vue?vue&type=template&id=0a2b1b74&scoped=true"
import script from "./MessengerPageSelector.vue?vue&type=script&lang=ts"
export * from "./MessengerPageSelector.vue?vue&type=script&lang=ts"
import style0 from "./MessengerPageSelector.vue?vue&type=style&index=0&id=0a2b1b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b1b74",
  null
  
)

export default component.exports